/**
 * @generated SignedSource<<07ad9be05ee7223bfe158ff55c5be360>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DisplayPromoCode_viewer$data = {
  readonly promoCodeMessaging: boolean | null;
  readonly " $fragmentType": "DisplayPromoCode_viewer";
};
export type DisplayPromoCode_viewer$key = {
  readonly " $data"?: DisplayPromoCode_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"DisplayPromoCode_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DisplayPromoCode_viewer",
  "selections": [
    {
      "alias": "promoCodeMessaging",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "promoCodeMessaging"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"promoCodeMessaging\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "cd7a1caeb8c5795d10c13c67164b708a";

export default node;
